import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ModalService } from '../../../services/modal/modal.service';

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrl: './sidebar.component.scss',
    standalone: false
})
export class SidebarComponent {
  constructor(private router: Router, public modalService: ModalService) { }
  
  logout() {
    localStorage.removeItem('access_token');
    this.router.navigate(['/login']);
  }

  openModal(popup: string) {
    this.modalService.openModal(popup);
  }
}
